import { useEffect, useMemo, useRef } from "react";

const useCurrentIframe = (onSetIframe, onSetIframeWrapper) => {
    const iframeRef = useRef(null);
    const iframeWrapperRef = useRef(null);

    useEffect(
        () => {
            if(iframeRef.current) {
                onSetIframe(iframeRef);
            }

            if(iframeWrapperRef.current) {
                onSetIframeWrapper(iframeWrapperRef);
            }
        },
        [ onSetIframe, iframeRef, onSetIframeWrapper ]
    );

    return useMemo(
        () => ({ iframeRef, iframeWrapperRef }),
        []
    );
};

export default useCurrentIframe;
